import React from 'react';
import { Button, ButtonProps } from './button.component';


export type AsyncButtonProps<C extends React.ElementType = 'button'> = {
  onClick: () => Promise<unknown>;
} & Omit<ButtonProps<C>, 'onClick'>;


export const AsyncButton = React.forwardRef(
  function _AsyncButton<C extends React.ElementType>(
    { onClick, ...props }: AsyncButtonProps<C>,
    ref: React.ForwardedRef<HTMLButtonElement>
  ) {
    const [ loading, setLoading ] = React.useState(false);
    const mountedRef = React.useRef(true);

    React.useEffect(() => () => {
      mountedRef.current = false;
    }, []);

    return (
      <Button
        {...props}
        ref={ref}
        loading={loading}
        onClick={(e: MouseEvent) => {
          e.stopPropagation();

          (async () => {
            setLoading(true);
            try {
              await onClick?.();
            } finally {
              if (mountedRef.current) {
                setLoading(false);
              }
            }
          })();
        }}
      />
    );
  });
